module.exports = __webpack_public_path__ + "static/img/sj_t.2b3019b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj_t.png
// module id = r+sp
// module chunks = 1